import type { ComponentPodcastPodcastPlatformLink } from '@edwin-group/people-graphql';
import { PodcastPlatform } from '@/components/PodcastPlatform';

interface PodcastListenAtProps {
  label?: string | null;
  platforms?: (ComponentPodcastPodcastPlatformLink | null)[] | null;
}

export const PodcastListenAt = ({ label, platforms }: PodcastListenAtProps) => {
  if (!platforms || platforms.length === 0) return null;

  const validPlatforms = platforms.filter(
    (platform): platform is ComponentPodcastPodcastPlatformLink => platform !== null,
  );

  if (validPlatforms.length === 0) return null;

  const heading = label || 'Listen at';

  return (
    <div className="mt-[16px] flex flex-wrap items-center gap-sh-16 rounded-[16px] border border-people-green-100 px-[16px] py-[16px] md:px-[48px]">
      <div className="flex flex-wrap items-center justify-center gap-[16px]">
        <span className="mr-sh-8 font-haffer text-sh-12-18 font-bold text-black">{heading}</span>
        {validPlatforms.map((item) => (
          <PodcastPlatform key={`${item.platform?.name ?? ''}-${item.url ?? ''}`} item={item} />
        ))}
      </div>
    </div>
  );
};
